module.exports = __webpack_public_path__ + "static/media/Illus-BowlEmpty.1854db98.png";